(() => {
  const payload = document.getElementById('CharterhouseProductSchemaData');
  if (!payload) return;
  const page = JSON.parse(payload.textContent);
  const appBlock = '[id$="__8882555360308167327"]';
  const types = node => [].concat(node?.['@type'] || []);
  const isProduct = node => types(node).some(type => ['Product', 'ProductGroup'].includes(type));
  const nodes = data => Array.isArray(data) ? data : data?.['@graph'] || [data];
  const encode = data => JSON.stringify(data).replace(/</g, '\\u003c');
  const parse = script => { try { return JSON.parse(script.textContent); } catch { return null; } };
  const matches = node => {
    try { return new URL(node.url || node['@id'], page.url).pathname === new URL(page.url).pathname; }
    catch { return node.name === page.title; }
  };
  const absolute = value => {
    try { return new URL(value, page.url).href; } catch { return value; }
  };
  function validBarcode(value) {
    const barcode = String(value || '').trim();
    if (!/^(?:\d{8}|\d{12}|\d{13}|\d{14})$/.test(barcode)) return null;
    let sum = 0;
    for (let i = barcode.length - 2, weight = 3; i >= 0; i--, weight = weight === 3 ? 1 : 3) sum += Number(barcode[i]) * weight;
    return (10 - sum % 10) % 10 === Number(barcode[barcode.length - 1]) ? barcode : null;
  }
  function assignBarcode(product, candidate) {
    const barcode = validBarcode(candidate);
    for (const key of ['gtin', 'gtin8', 'gtin12', 'gtin13', 'gtin14']) {
      if (!barcode || key !== 'gtin' + barcode.length) delete product[key];
    }
    if (barcode) product['gtin' + barcode.length] = barcode;
  }
  function clean(node) {
    if (!node || typeof node !== 'object') return;
    if (Array.isArray(node)) { node.forEach(clean); return; }
    if (node.type === 'Offer' || node.type === 'Brand') { node['@type'] = node.type; delete node.type; }
    if (node.url) node.url = absolute(node.url);
    if (node['@id']) node['@id'] = absolute(node['@id']);
    if (isProduct(node)) {
      const offer = Array.isArray(node.offers) ? node.offers[0] : node.offers;
      const barcode = node.gtin || node.gtin8 || node.gtin12 || node.gtin13 || node.gtin14 || offer?.gtin || offer?.gtin8 || offer?.gtin12 || offer?.gtin13 || offer?.gtin14;
      assignBarcode(node, barcode);
      if (node.brand) node.brand['@type'] = 'Brand';
      if (node.variesBy) node.variesBy = node.variesBy.map(value => value.replace(/\/colour$/, '/color'));
      if (node.colour) { node.color = node.colour; delete node.colour; }
      if (node.productGroupID != null) node.productGroupID = String(node.productGroupID);
    }
    if (types(node).some(type => ['Offer', 'AggregateOffer'].includes(type))) {
      delete node.shippingDetails;
      delete node.hasMerchantReturnPolicy;
      for (const key of ['gtin', 'gtin8', 'gtin12', 'gtin13', 'gtin14']) delete node[key];
    }
    Object.values(node).forEach(clean);
  }
  function mergeReviews(product, reviews) {
    delete product.aggregateRating;
    delete product.review;
    const rating = reviews?.aggregateRating;
    if (rating && Number(rating.ratingValue) >= 1 && Number(rating.ratingValue) <= 5 && Number(rating.reviewCount || rating.ratingCount) > 0) {
      product.aggregateRating = rating;
      if (reviews.review) product.review = reviews.review;
    }
  }
  function enrichVariants(product) {
    const productJson = document.querySelector('script[id^="ProductJson-"]');
    const variants = parse(productJson)?.variants || [];
    const attributes = { color: 'color', colour: 'color', size: 'size', material: 'material', pattern: 'pattern' };
    if (!product.hasVariant) return;
    product.hasVariant.forEach(variant => {
      const url = new URL(variant.url || variant.offers?.url || page.url, page.url);
      const source = variants.find(item => String(item.id) === url.searchParams.get('variant'));
      variant['@id'] = page.url + '#variant-' + (url.searchParams.get('variant') || variant.sku);
      variant.isVariantOf = { '@id': product['@id'] };
      if (!source) return;
      page.options.forEach((option, index) => {
        const attribute = attributes[String(option).toLowerCase()];
        if (attribute && source.options?.[index]) variant[attribute] = source.options[index];
      });
    });
  }
  function consolidate() {
    const reviewScript = document.getElementById('reviewsWidgetProductSnippets');
    const reviewData = reviewScript && parse(reviewScript);
    const reviews = nodes(reviewData).find(node => isProduct(node) && matches(node));
    const candidates = Array.from(document.querySelectorAll(appBlock + ' script[type="application/ld+json"]'));
    const appScript = candidates.find(script => nodes(parse(script)).some(node => isProduct(node) && matches(node)));
    const fallback = document.getElementById('CharterhouseProductFallback');
    const chosen = appScript || fallback;
    if (!chosen) return;
    const data = parse(chosen);
    const product = nodes(data).find(node => isProduct(node) && matches(node));
    if (!product) return;
    clean(product);
    product['@id'] = page.url + '#product';
    if (page.image) product.image = page.image;
    mergeReviews(product, reviews);
    enrichVariants(product);
    const updated = encode(data);
    if (chosen.textContent !== updated) chosen.textContent = updated;
    if (chosen.type !== 'application/ld+json') chosen.type = 'application/ld+json';
    if (appScript && fallback && fallback.type !== 'application/json') fallback.type = 'application/json';
    if (reviews && reviewScript.type !== 'application/json') reviewScript.type = 'application/json';
  }
  let queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; consolidate(); });
  }
  const relevant = node => node?.nodeType === 1 && (node.matches?.('script[type="application/ld+json"], #reviewsWidgetProductSnippets') || node.querySelector?.('script[type="application/ld+json"], #reviewsWidgetProductSnippets'));
  new MutationObserver(records => {
    if (records.some(record => record.target.nodeName === 'SCRIPT' || record.target.parentElement?.nodeName === 'SCRIPT' || Array.from(record.addedNodes).some(relevant))) schedule();
  }).observe(document.documentElement, { subtree: true, childList: true, characterData: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', consolidate, { once: true });
  else consolidate();
})();
